import { c as _c } from "react-compiler-runtime";
import { useCallback, useMemo, memo } from 'react';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { useSelectionDispatch, useSelectionSelector } from '../../redux/reduxHooks';
import { clearSelection, getIsQuerySelected, getSelectedRowIds, selectQuery, setRowsSelected } from '../redux/selectionSlice';
import { useIsInfiniteScrollEnabled } from '../../table/context/InfiniteScrollContext';
import I18n from 'I18n';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const SelectAllCheckboxHeader = t0 => {
  const $ = _c(13);
  const {
    rowIds
  } = t0;
  const isInfiniteScroll = useIsInfiniteScrollEnabled();
  const selectedRowIds = useSelectionSelector(getSelectedRowIds);
  const isQuerySelected = useSelectionSelector(getIsQuerySelected);
  let t1;
  if ($[0] !== rowIds || $[1] !== selectedRowIds) {
    t1 = rowIds.length > 0 && rowIds.every(rowId => selectedRowIds.has(rowId));
    $[0] = rowIds;
    $[1] = selectedRowIds;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isCurrentPageSelected = t1;
  const isChecked = isInfiniteScroll ? isQuerySelected : isCurrentPageSelected;
  const isIndeterminate = isInfiniteScroll ? !isQuerySelected && selectedRowIds.size > 0 : selectedRowIds.size > 0;
  const dispatch = useSelectionDispatch();
  let t2;
  if ($[3] !== dispatch || $[4] !== isChecked || $[5] !== isInfiniteScroll || $[6] !== rowIds) {
    t2 = t3 => {
      const {
        target: t4
      } = t3;
      const {
        checked
      } = t4;
      if (!isInfiniteScroll) {
        dispatch(setRowsSelected(rowIds.map(rowId_0 => ({
          rowId: rowId_0,
          selected: checked
        }))));
        return;
      }
      if (isChecked) {
        dispatch(clearSelection());
      } else {
        dispatch(setRowsSelected(rowIds.map(_temp)));
        dispatch(selectQuery());
      }
    };
    $[3] = dispatch;
    $[4] = isChecked;
    $[5] = isInfiniteScroll;
    $[6] = rowIds;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleChange = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = I18n.text("datatable.bulkActions.selectAllCheckboxLabel");
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== handleChange || $[10] !== isChecked || $[11] !== isIndeterminate) {
    t4 = /*#__PURE__*/_jsx("th", {
      scope: "col",
      "data-test-id": "checkbox-select-all-container",
      "data-selection-column": true,
      children: /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        justifyContent: "center",
        flexGrow: 1,
        children: /*#__PURE__*/_jsx(Checkbox, {
          "aria-label": t3,
          "data-test-id": "checkbox-select-all",
          checked: isChecked,
          indeterminate: isIndeterminate,
          onChange: handleChange
        })
      })
    });
    $[9] = handleChange;
    $[10] = isChecked;
    $[11] = isIndeterminate;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
export default /*#__PURE__*/memo(SelectAllCheckboxHeader);
function _temp(rowId_1) {
  return {
    rowId: rowId_1,
    selected: true
  };
}